module.exports = __webpack_public_path__ + "img/01_map.cabe2487.webp";